import React from 'react'
import '../pages/pages.css'
import '../components/components.css'
import { NavLink } from 'react-router'

const About = () => {
  return (
    <div  id='about'>
        <div id='header-title'>
            <NavLink to="/">josh popp</NavLink>
        </div>
        <div>
            <p>elegant with a touch of euroswag.</p>
            <p>extensive background in web development to create whatever your little  heart desires.</p>
            <p>with a background in software engineering, we can even take it further than just a website.</p>
            <p>let's build something!</p>
            <a href="mailto:joshpoppdev@gmail.com" target="_blank"><p>joshpoppdev@gmail.com</p></a>
        </div>
    </div>
  )
}

export default About